import React, { FunctionComponent } from "react";
import CheckboxWithLabelSmily from "@Components/atoms/CheckboxWithLabelSmily";
import { Upsell } from "@Types/upsells";
import "./style.scss";

interface Props {
  isSelected: boolean;
  onSelectChange: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  upsell: Upsell;
}

const UpsellItem: FunctionComponent<Props> = ({
  isSelected,
  onSelectChange,
  onMouseEnter,
  onMouseLeave,
  upsell,
}) => {
  return (
    <div
      className="UpsellItem"
      onClick={onSelectChange}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="UpsellItem-top">
        <CheckboxWithLabelSmily
          checked={isSelected}
          onChange={onSelectChange}
          size="m"
          type="primary"
        />
        <div className="UpsellItem-title">{upsell.title}</div>
      </div>
      <div className="UpsellItem-infos">
        <div className="UpsellItem-description">{upsell.description}</div>
        <div className="UpsellItem-price">{upsell.price.formattedPrice}</div>
      </div>
    </div>
  );
};

export default UpsellItem;
